import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaSearch } from "react-icons/fa";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

export default function CustomerTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");

  // --- Filter States ---
  const [searchName, setSearchName] = useState("");
  const [searchDivision, setSearchDivision] = useState("");

  useEffect(() => {
    fetchFailedCollectFee();
  }, []);

  const fetchFailedCollectFee = async () => {
    setIsLoading(true);
    try {
      const payload = {
            customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
        language: "en",
        division_id: "",
        student_name: searchName,
      };

      const response = await simplePostCall(
        ApiConfig.customersList,
        JSON.stringify(payload),
      );

      if (response?.result) {
        const formattedData = response.academicYear.map((item, index) => ({
          id: index + 1,
          name: item.student_name || "",
          grade: item.class_name || "",
          division: item.class_division_name || "",
          invoiceno: item.student_id,
        }));

        setData(formattedData);
        setMessage("Data retrieved successfully");
      } else {
        setMessage(response?.message || "No results found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      setMessage("Error fetching details");
    } finally {
      setIsLoading(false);
    }
  };

  // --- Filtering Logic ---
  const filteredData = data.filter((item) => {
    return (
      item.name.toLowerCase().includes(searchName.toLowerCase()) &&
      item.division.toLowerCase().includes(searchDivision.toLowerCase())
    );
  });

  const handleClear = () => {
    setSearchName("");
    setSearchDivision("");
  };

  return (
    <div className="customer-container my-4">
      <div className="special-header panel-white-all">
        <h4 className="page-title mt-1">Customer</h4>
      </div>

      <div className="table-top-filters d-flex align-items-center flex-wrap gap-3 mb-3">
        {/* STUDENT NAME FILTER */}
        <div style={{ position: "relative", maxWidth: "200px" }}>
          <FaSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "-5px",
              transform: "translateY(-50%)",
              fontSize: "13px",
              color: "#999",
            }}
          />
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Student Name"
            style={{ paddingLeft: "30px", height: "38px"}}
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
          />
        </div>

        {/* STUDENT DIVISION FILTER */}
        <div style={{ position: "relative", maxWidth: "200px" }}>
       
          
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          style={{ height: "38px" ,width:'80px', backgroundColor:'#5db2e8', borderColor:'#5db2e8', marginLeft: "-10px"}}
          onClick={handleClear}
        >
          Clear
        </button>
      </div>

      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="custom-table w-100">
              <thead>
                <tr>
                  <th className="text-center">Sr No</th>
                  <th className="text-center">Student Name</th>
                  <th className="text-center">Grade</th>
                  <th className="text-center">Division</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center p-2">
                      <div className="text-center">
                        <ScaleLoader color="#F4BB44" />
                      </div>
                    </td>
                  </tr>
                ) : filteredData.length > 0 ? (
                  filteredData.map((row) => (
                    <tr key={row.id}>
                      <td
                        className="text-center"
                        style={{ fontSize: "13px", height: "50px" }}
                      >
                        {row.id}
                      </td>
                      <td
                        className="text-center"
                        style={{ fontSize: "13px", height: "50px" }}
                      >
                        {row.name}
                      </td>
                      <td
                        className="text-center"
                        style={{ fontSize: "13px", height: "50px" }}
                      >
                        {row.grade}
                      </td>
                      <td
                        className="text-center"
                        style={{ fontSize: "13px", height: "50px" }}
                      >
                        {row.division}
                      </td>
                      <td className="text-center" style={{ height: "50px" }}>
                        <button
                        style={{display:'flex' , justifyContent:'center' , alignItems:'center', gap:'6px' ,margin:'0 auto'}}
                          type="button"
                          className="btn"
                          onClick={() =>
                            navigate(`/ViewInvoiceCustomer/${row.invoiceno}`)
                          }
                          title="View"
                        >
                         <FaEye />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center p-3">
                      {message || "No Data Found matching your search"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
